import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ApplicationState } from 'store';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import { consumeFidelizeLoginRedirect } from 'store/modules/conlicitaseg_store/actions';
import { QUOTE_INTRO_PATH } from 'services/conlicitaseg';

function useReleaseFidelizeLoginRedirect(): void {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { fidelize_login_redirect_pending } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );

  useEffect(() => {
    if (fidelize_login_redirect_pending && pathname !== QUOTE_INTRO_PATH) {
      dispatch(consumeFidelizeLoginRedirect());
    }
  }, [dispatch, fidelize_login_redirect_pending, pathname]);
}

export default useReleaseFidelizeLoginRedirect;
